import { Protected } from "@/components/layout/Protected";
import { Box, Grid, Container, Typography, IconButton, SelectChangeEvent, Autocomplete, Button, InputAdornment, FormControl, FormControlLabel, Checkbox, Stack, FormGroup, RadioGroup, } from '@mui/material'
import React, { useState, useRef } from "react";
import { Props } from "../DataBooks.type"
import { Input } from '@components/common/Input';
import { InputRef } from '@components/common/Input/InputInterfaces';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import EmailIcon from '@mui/icons-material/Email';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import DatePicker from '@mui/lab/DatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import TableBody from '@mui/material/TableBody';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import TableCell from '@mui/material/TableCell';
import NumbersIcon from '@mui/icons-material/Numbers';
import TableContainer from '@mui/material/TableContainer';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PhoneIcon from '@mui/icons-material/Phone';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import AssignmentIcon from '@mui/icons-material/Assignment';
import NextWeekIcon from '@mui/icons-material/NextWeek';
import TableRow from '@mui/material/TableRow';
import Radio from '@mui/material/Radio';
// import '../Workers.css'
import TextField from '@mui/material/TextField';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import { DeleteIcon } from "@/toolbox/constants/icons";

interface Column {
   id: 'folio' | 'fecha' | 'hora' | 'destinatario';
   label: string;
   minWidth?: number;
   align?: 'right';
   format?: (value: number) => string;
}

const columns: readonly Column[] = [
   { id: 'folio', label: 'Folio', minWidth: 10 },
   { id: 'fecha', label: 'Fecha', minWidth: 50 },
   { id: 'hora', label: 'Hora', minWidth: 50 },
   { id: 'destinatario', label: 'Destinatario', minWidth: 100 },
];

interface Data {
   folio: number;
   fecha: string;
   hora: string;
   destinatario: string;
}

function createDataProviders(
   folio: number,
   fecha: string,
   hora: string,
   destinatario: string,
): Data {
   return { folio, fecha, hora, destinatario };
}

const rowsData = [
   createDataProviders(407,'2022-02-01','17:20:18','desarrollo@softnet.cl'),
   createDataProviders(407,'2022-02-01','17:20:18','desarrollo@softnet.cl'),
   createDataProviders(407,'2022-02-01','17:20:18','desarrollo@softnet.cl'),
   createDataProviders(407,'2022-02-01','17:20:18','desarrollo@softnet.cl'),
   createDataProviders(407,'2022-02-01','17:20:18','desarrollo@softnet.cl'),
   createDataProviders(407,'2022-02-01','17:20:18','desarrollo@softnet.cl'),
   createDataProviders(407,'2022-02-01','17:20:18','desarrollo@softnet.cl'),
   createDataProviders(407,'2022-02-01','17:20:18','desarrollo@softnet.cl'),
   createDataProviders(407,'2022-02-01','17:20:18','desarrollo@softnet.cl'),
   createDataProviders(407,'2022-02-01','17:20:18','desarrollo@softnet.cl')
]

export const DataModalHistorySend: React.FC<Props> = (props: Props): JSX.Element => {
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [value, setValue] = useState('');
   const [loading, setLoading] = useState(false);
   const [ejecutivoComercial, setEjecutivoComercial] = useState('');
   const [estado, setEstado] = useState('');
   // const [data, setData] = React.useState<Date | null>(new Date());
   const [data, setData] = React.useState<Date | null>(
      new Date('2018-01-01T00:00:00.000Z'),
   );
   const inputRefs = useRef<Array<InputRef | null>>([]);

   //radio buttoms
   const [valueRadio, setValueRadio] = React.useState('female');

   const handleChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
      setValueRadio((event.target as HTMLInputElement).value);
   };

   const handleChangeEjecutivoComercial = (event: SelectChangeEvent) => {
      setEjecutivoComercial(event.target.value);
   };
   const handleChangeEstado = (event: SelectChangeEvent) => {
      setEstado(event.target.value);
   };
   function handleClick() {
      setLoading(true);
   }

   const handleChangePage = (event: unknown, newPage: number) => {
      setPage(newPage);
   };

   const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
   };

   const estadoValue = [
      { label: 'ACTIVADO', value: 'activado' },
      { label: 'DESACTIVADO', value: 'desactivado' }
   ]
   const parentescoValue = [
      { label: 'Esposa' },
      { label: 'Esposo' },
      { label: 'Hija' },
      { label: 'Hijo' },
      { label: 'Padre' },
      { label: 'Madre' },
      { label: 'Otro' }
   ]
   const contacto = [
      { label: 'Jorge Roberto' }
   ]
   const cargaValue = [
      { label: 'Simple' },
      { label: 'Duplo' },
      { label: 'Maternal' }
   ]

   return (
      <Container maxWidth='xl'>
         <Grid container spacing={3} mt={2} >
            <Grid item container mb={2}>
               <Grid item xs={10}>
                  <Typography variant="h6" id="modal-modal-title" className='tittle'>
                     Historial de Envios
                  </Typography>
               </Grid>
               <Grid item xs={2} textAlign="end">
                  <AssignmentIcon style={{ color: '#FF9700' }} />
               </Grid>
            </Grid>
            <Grid item xs={12}>
               <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                  <TableContainer sx={{ maxHeight: 250 }}>
                     <Table stickyHeader aria-label="sticky table" size="small">
                        <TableHead>
                           <TableRow>
                              {columns.map((column) => (
                                 <TableCell

                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                 >
                                    {column.label}
                                 </TableCell>
                              ))}
                           </TableRow>
                        </TableHead>
                        <TableBody>
                           {rowsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                              return (
                                 <TableRow hover role="checkbox" tabIndex={-1} key={row.folio}>
                                    {columns.map((column) => {
                                       const value = row[column.id];
                                       return (
                                          <TableCell  key={column.id} align={column.align}>
                                             {column.format && typeof value === 'number'
                                                ? column.format(value)
                                                : value}
                                          </TableCell>
                                       );
                                    })}

                                 </TableRow>
                              );
                           })}

                        </TableBody>
                     </Table>
                  </TableContainer>
                  <TablePagination
                     rowsPerPageOptions={[10, 25, 100]}
                     component="div"
                     count={rowsData.length}
                     rowsPerPage={rowsPerPage}
                     page={page}
                     onPageChange={handleChangePage}
                     onRowsPerPageChange={handleChangeRowsPerPage}
                  />
               </Paper>
            </Grid>
            <Grid container mt={2}>
               <Grid item xs={12} textAlign="center">
                  <button className='btn_add'>
                     Enviar Gmail
                  </button>
               </Grid>

            </Grid>
            {/* <Grid xs={12}>
               <Typography variant="h6" gutterBottom mb={3} className="tittle2" align="center" mt={2}>
                  LISTADO DE CARGAS FAMILIARES
               </Typography>
            </Grid> */}
         </Grid>




      </Container >
   );
};

